import React from 'react';

export default function VariantDetailsForm({
  title,
  onTitleChange,
  price,
  onPriceChange,
  barcode,
  onBarcodeChange,
  requireTitle = true,
}) {
  return (
    <>
      <section className="shop-create-section">
        <label className="shop-create-label" htmlFor="variant-title">
          Название варианта
          {requireTitle ? <b style={{ color: 'red' }}> *</b> : null}
        </label>
        <input
          id="variant-title"
          className="shop-create-input"
          placeholder="Размер, цвет…"
          value={title}
          onChange={(e) => onTitleChange(e.target.value)}
          autoComplete="off"
          autoFocus
        />
      </section>

      <section className="shop-create-section">
        <label className="shop-create-label" htmlFor="variant-price">
          Цена <b style={{ color: 'red' }}>*</b>
        </label>
        <input
          id="variant-price"
          className="shop-create-input"
          placeholder="например, 199"
          value={price}
          onChange={(e) => onPriceChange(e.target.value)}
          autoComplete="off"
          inputMode="decimal"
        />
      </section>

      <section className="shop-create-section">
        <label className="shop-create-label" htmlFor="variant-barcode">
          Штрихкод (необязательно)
        </label>
        <input
          id="variant-barcode"
          className="shop-create-input"
          placeholder="Barcode"
          value={barcode}
          onChange={(e) => onBarcodeChange(e.target.value)}
          autoComplete="off"
        />
      </section>
    </>
  );
}
